<template>
  <div id="InstrumentSelectModal">
    <div class="modal-card" style="width:900px;">
      <header class="modal-card-head">
        <p class="modal-card-title" style="color: whitesmoke;">機器選択</p>
      </header>
      <section class="modal-card-body">
        <!--検索条件 -->
        <div class="condition-area">
          <table class="conditionTable">
            <tr>
              <th>保管場所コード</th>
              <td colSpan="6">
                <select v-model="depositoryCode">
                  <option value=""></option>
                  <option v-for="item in depositoryCodeMaster" :key="item.depositoryCode" :value="item.depositoryCode">{{item.depositoryName}}({{item.depositoryCode}})</option>
                </select>
              </td>
            </tr>
            <tr>
              <template v-if="type==0">
                <th>機種</th>
                <td>
                  <select v-model="model">
                    <option v-for="model in modelList" :value="model.itemCode" :key="model.itemCode">{{ model.itemName }}</option>
                  </select>
                </td>
              </template>
              <template v-else>
                <th>品目コード</th>
                <td>
                  <input type="text" v-model="itemCode" maxlength="50"/>
                </td>
              </template>
              <template v-if="type==0 || type==1 || type==2">
              <th>シリアル</th>
              <td>
                <input type="text" v-model="serial" maxlength="50"/>
              </td>
              </template>
              <template v-else>
              <th>ロット</th>
              <td>
                <input type="text" v-model="lot" maxlength="50"/>
              </td>
              </template>
            </tr>
            <tr>
              <th>持出者名</th>
              <td>
                <input type="text" v-model="takingOutStaff" maxlength="256"/>
              </td>
              <th>持出先名</th>
              <td>
                <input type="text" v-model="takingOutDestination" maxlength="256"/>
              </td>
            </tr>
            <tr>
              <th>持出日</th>
              <td colspan="3">
                  <input type="date" v-model="takingOutDateStart"/>
              ～ <input type="date" v-model="takingOutDateEnd"/>
              </td>
            </tr>
          </table>
          <div class="searchButton-area" style="margin-bottom:10px;text-align: center;">
            <!-- <b-button class="is-primary" @click="doSearch" :disabled="!depositoryCode">検索</b-button> -->
            <b-button class="is-primary" @click="doSearch" >検索</b-button>
            <br/><span v-if="!depositoryCode" style="color:red; font-size:15px;">※保管場所コードを選択してください</span>
          </div>
        </div>
        <!-- 検索結果 -->
        <div class="result-area">
          <b-table
            v-if="data.length > 0"
            id="tempDeviceSelectTable"
            :data="data"
            paginated
            per-page="20"
            pagination-position="both"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <template slot-scope="props">
              <b-table-column field="instrumentId" label="" width="5" centered>
                <b-radio class="customRadio" name="radioItem" v-model="selectedItem" :native-value="props.row"></b-radio>
              </b-table-column>
              <b-table-column field="itemCode" label="品目コード" width="80" centered>{{props.row.itemCode }}</b-table-column>
              <b-table-column field="itemName" label="機種" width="150" centered>{{props.row.itemName }}</b-table-column>
              <b-table-column v-if="type==0 || type==1 || type==2" field="serial" label="シリアル" width="80" centered>{{props.row.serial }}</b-table-column>
              <b-table-column v-else field="lot" label="ロット" width="80" centered>{{props.row.lot }}</b-table-column>
              <!-- <b-table-column field="id" label="仮持出ID" width="100" centered>{{props.row.id }}</b-table-column> -->
              <b-table-column field="takingOutDate" label="持出日" width="80" centered>{{props.row.takingOutDate }}</b-table-column>
              <b-table-column field="takingOutStaff" label="持出者" width="100" centered>{{props.row.takingOutStaff }}</b-table-column>
              <b-table-column field="takingOutDestination" label="持出先" width="150" centered>{{props.row.takingOutDestination }}</b-table-column>
            </template>
          </b-table>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="save" :disabled="!selectedItem">決定</button>
        <button class="button" type="button" @click="$parent.close()">閉じる</button>
      </footer>
    </div>
  </div>
</template>
<script>
export default {
  name: "InstrumentSelectModal",
  props: {
    title:{default:"機器選択"},
    selectModel:"",
    selectItemCode:"",
    selectSerial:"",
    searchType:"",
    belongsId:"",
    institutionId:""
  },
  methods: {
    save: function() {
      this.$emit('select', this.selectedItem);
      this.$parent.close();
    },
    getDepositoryCodeMaster: function() {
      this.depositoryCodeMaster = []
      if(!this.officeCode) return
      // Web Api Call
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.apiCommon.getCpapStorageLocationPOST({
            body:{
              belongsId: _this.belongsId,
              institutionId: _this.institutionId,
              salesOfficeCode: "J"+_this.officeCode
            }
          });
        },
        async function(result){
          _this.depositoryCodeMaster = result.obj;
          var targetOffice = _this.depositoryCodeMaster.find(val => val.depositoryCode=="J"+_this.officeCode)
          if(targetOffice){
            _this.depositoryCode = targetOffice.depositoryCode
          }
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
    doSearch: function() {
      // if(!this.depositoryCode){
      //   this.showErrorMessage("保管場所コードは必須項目です。")
      //   return;
      // }
      // Web Api Call
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.internalCpap.getCpapTemporaryTakeOutListPOST({
            body:{
              depositoryCode: _this.depositoryCode,
              model:  _this.model,
              itemCode:_this.itemCode,
              serial: _this.serial,
              lot: _this.lot,
              takingOutStaff:_this.takingOutStaff,
              takingOutDestination:_this.takingOutDestination,
              takingOutDateStart:_this.takingOutDateStart,
              takingOutDateEnd:_this.takingOutDateEnd,
              searchType:_this.type
            }
          });
        },
        async function(result){
          if(result.obj.length < 1){
            _this.showMessage('該当する機器情報は存在しません。');
          }
          _this.data = result.obj;
        },
        function(result){
          _this.showErrorMessage(result);
        }
      ); 
    },
  },
  data() {
    var modelList = []
    let deviceMaster = this.getCpapMaster();
    for(let device of deviceMaster){
      for(let item of device.items){
        modelList.push({
          itemCode:item.itemCode,
          itemName:item.itemName
        })
      }
    }
    modelList.unshift({})
    // var branchOfficeMaster= this.getBranchOfficeMaster();
    var branchOfficeMaster= this.getSalesOfficeMaster();
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    return {
      modelList,
      branchOfficeMaster,
      data: [],
      officeCode:userInfo.salesOfficeCode,
      depositoryCode:"",
      model:this.selectModel,
      itemCode:this.selectItemCode,
      serial:this.selectSerial,
      type:this.searchType,
      takingOutStaff:"",
      takingOutDestination:"",
      takingOutDateStart:"",
      takingOutDateEnd:"",
      selectedItem:'',
      depositoryCodeMaster:[],
      belongsId:this.belongsId,
      institutionId:this.institutionId
    };
  },
  filters: {},
  components: {},
  mounted: function () {
    this.getDepositoryCodeMaster()
  },
};
</script>
<style lang="scss" scoped>
.customRadio {
  width:10px;
}
.result-area {
  height: 450px;
}
input {
  width: 300px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/common/InstrumentSelectModal.vue